// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ShareModal_modal__HRL\\+a{
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 400;
}
.ShareModal_container__\\+N-sF{
    position: relative;
    width: 85%;
    max-width: 412px;
    padding: 20px;
    background-color: #FFFFFF;
    border: 1px solid #1F363D1A;
    border-radius: 25px;
    box-shadow: 0 3px 12px 0 #00000012;
}
.ShareModal_header__0eB5P{
    margin-bottom: 8px;
    color: #1F363D;
    font-size: 31px;
    font-family: 'Gotham Bold', serif;
}
.ShareModal_close__wI\\+ea{
    position: absolute;
    top: 28px;
    right: 33px;
    height: 12px;
    width: 12px;
    cursor: pointer;
}
.ShareModal_buttons__\\+7-2h{
    display: flex;
    flex-wrap: wrap;
}
.ShareModal_button__y1FrJ{
    justify-content: left;
    width: 194px;
    margin-top: 15px;
}
@media(max-width: 500px){
    .ShareModal_button__y1FrJ{
        width: 100%;
        margin-right: 0 !important;
    }
}
.ShareModal_copyButton__pMBx6 > img{
    height: 10px;
    width: 20px;
    margin-right: 10px;
}
.ShareModal_copiedButton__-Yj1X{
    background-color: #F0F6F5;
    border-color: #70A9A11A;
}
.ShareModal_copiedButton__-Yj1X > img{
    height: 12px;
    width: 16px;
    margin-right: 14px;
}
.ShareModal_emailButton__Gmatl > img{
    height: 20px;
    width: 22px;
    margin-right: 10px;
}
.ShareModal_xButton__6dN\\+- > img{
    height: 17px;
    width: 19px;
    margin-right: 12px;
}
.ShareModal_facebookButton__tPnQP > img{
    height: 21px;
    width: 11px;
    margin-right: 21px;
}
.ShareModal_button__y1FrJ:nth-of-type(odd){
    margin-right: 15px;
}`, "",{"version":3,"sources":["webpack://./src/components/modals/ShareModal.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,WAAW;IACX,oCAAoC;IACpC,YAAY;AAChB;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,aAAa;IACb,yBAAyB;IACzB,2BAA2B;IAC3B,mBAAmB;IACnB,kCAAkC;AACtC;AACA;IACI,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iCAAiC;AACrC;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,WAAW;IACX,eAAe;AACnB;AACA;IACI,aAAa;IACb,eAAe;AACnB;AACA;IACI,qBAAqB;IACrB,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI;QACI,WAAW;QACX,0BAA0B;IAC9B;AACJ;AACA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,yBAAyB;IACzB,uBAAuB;AAC3B;AACA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,kBAAkB;AACtB","sourcesContent":[".modal{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: fixed;\n    top: 0;\n    left: 0;\n    height: 100%;\n    width: 100%;\n    background-color: rgba(0, 0, 0, 0.5);\n    z-index: 400;\n}\n.container{\n    position: relative;\n    width: 85%;\n    max-width: 412px;\n    padding: 20px;\n    background-color: #FFFFFF;\n    border: 1px solid #1F363D1A;\n    border-radius: 25px;\n    box-shadow: 0 3px 12px 0 #00000012;\n}\n.header{\n    margin-bottom: 8px;\n    color: #1F363D;\n    font-size: 31px;\n    font-family: 'Gotham Bold', serif;\n}\n.close{\n    position: absolute;\n    top: 28px;\n    right: 33px;\n    height: 12px;\n    width: 12px;\n    cursor: pointer;\n}\n.buttons{\n    display: flex;\n    flex-wrap: wrap;\n}\n.button{\n    justify-content: left;\n    width: 194px;\n    margin-top: 15px;\n}\n@media(max-width: 500px){\n    .button{\n        width: 100%;\n        margin-right: 0 !important;\n    }\n}\n.copyButton > img{\n    height: 10px;\n    width: 20px;\n    margin-right: 10px;\n}\n.copiedButton{\n    background-color: #F0F6F5;\n    border-color: #70A9A11A;\n}\n.copiedButton > img{\n    height: 12px;\n    width: 16px;\n    margin-right: 14px;\n}\n.emailButton > img{\n    height: 20px;\n    width: 22px;\n    margin-right: 10px;\n}\n.xButton > img{\n    height: 17px;\n    width: 19px;\n    margin-right: 12px;\n}\n.facebookButton > img{\n    height: 21px;\n    width: 11px;\n    margin-right: 21px;\n}\n.button:nth-of-type(odd){\n    margin-right: 15px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `ShareModal_modal__HRL+a`,
	"container": `ShareModal_container__+N-sF`,
	"header": `ShareModal_header__0eB5P`,
	"close": `ShareModal_close__wI+ea`,
	"buttons": `ShareModal_buttons__+7-2h`,
	"button": `ShareModal_button__y1FrJ`,
	"copyButton": `ShareModal_copyButton__pMBx6`,
	"copiedButton": `ShareModal_copiedButton__-Yj1X`,
	"emailButton": `ShareModal_emailButton__Gmatl`,
	"xButton": `ShareModal_xButton__6dN+-`,
	"facebookButton": `ShareModal_facebookButton__tPnQP`
};
export default ___CSS_LOADER_EXPORT___;
